import { Injectable } from '@angular/core';
import {from, Observable} from "rxjs";
import { AwsApiWrapperService } from "@brightside-web/desktop/data-access/core-services";

export enum SupportedProgramsEnum {
  MPAP = 'MPAP',
  HELPING_HANDS = 'HELPING_HANDS'
}

export enum ProgramApplicationStatusEnum {
  CREATED = "created",
  SUBMITTED = "submitted",
  DOCS_REQUESTED = "documents_requested",
  DOCS_RECEIVED = "documents_received",
  IN_REVIEW = "in_review",
  APPROVED = "approved",
  DENIED = "denied",
  CLOSED = "closed",
  IN_PROGRESS = "in_progress"
}

export interface ProgramApplicationsInterface {
  "application_id": string,
  "guid": string,
  "product_type": SupportedProgramsEnum,
  "status": ProgramApplicationStatusEnum,
  "status_date": Date,
  "source": string
}

@Injectable({
  providedIn: 'root'
})
export class ProgramApplicationsService {

  constructor(private awsApiWrapperService: AwsApiWrapperService) { }

  getProdAppStatus(prodType: SupportedProgramsEnum) : Observable<ProgramApplicationsInterface>{
    return from(this.awsApiWrapperService.get('api-mobile', `/product/application?product_type=${prodType}`, {}));
  }
}
